// extracted by mini-css-extract-plugin
module.exports = {"shippingReport":"ShippingReport_shippingReport__1IIWs"};